var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDialogSign',{attrs:{"rgbaSignBorderColor":"rgba(255,215,94,0.7)","hexSignCoreColor":"#ffc107"}})}
var staticRenderFns = []

export { render, staticRenderFns }